import ListContainer from '../Common/ListContainer';
import LoadingSpinner from '../Common/LoadingSpinner';
import { Stack } from '@mui/material';
import ErrorBoundary from '../../hooks/errorBoundary';
import { DataGridPro, getGridDateOperators, getGridStringOperators, GridColDef, huHU } from '@mui/x-data-grid-pro';
import React from 'react';
import { WorkerDeviceDetailsByTravel } from '../../@types/employeeData';
import { format } from 'date-fns';
import EmptyListMessage from '../Common/EmptyListMessage';
import { WorkerDeviceDataGridProps } from './WorkerTravelDetailsPage';


const columns: GridColDef[] = [
    {
        field: 'workplaceName',
        headerName: 'Munkahely',
        width: 170,
        sortable: true,
        headerAlign: 'left',
        align: 'left',
        renderHeader: () => <strong>Munkahely</strong>,
        filterOperators: getGridStringOperators().filter(({ value }) => ['contains'].includes(value)),
    },
    {
        field: 'operationUnit',
        headerName: 'Üzemegység',
        width: 230,
        sortable: true,
        headerAlign: 'left',
        align: 'left',
        renderHeader: () => <strong>Üzemegység</strong>,
        filterOperators: getGridStringOperators().filter(({ value }) => ['contains'].includes(value)),
    },
    {
        field: 'line',
        headerName: 'Járat',
        width: 170,
        sortable: true,
        headerAlign: 'left',
        align: 'left',
        renderHeader: () => <strong>Járat</strong>,
        filterOperators: getGridStringOperators().filter(({ value }) => ['contains'].includes(value)),
    },
    {
        field: 'stop',
        headerName: 'Megálló',
        width: 230,
        sortable: true,
        headerAlign: 'left',
        align: 'left',
        renderHeader: () => <strong>Megálló</strong>,
        filterOperators: getGridStringOperators().filter(({ value }) => ['contains'].includes(value)),
    },
    {
        field: 'workerName',
        headerName: 'Dolgozó neve',
        flex: 1,
        sortable: false,
        headerAlign: 'left',
        align: 'left',
        renderHeader: () => <strong>Dolgozó neve</strong>,
        filterOperators: getGridStringOperators().filter(({ value }) => ['contains'].includes(value)),
    },
    {
        field: 'workerIdentifier',
        headerName: 'Dolgozó azonosító',
        width: 200,
        sortable: true,
        headerAlign: 'left',
        align: 'left',
        renderHeader: () => <strong>Dolgozó azonosító</strong>,
        filterOperators: getGridStringOperators().filter(({ value }) => ['contains'].includes(value)),
    },
    {
        field: 'departureAt',
        headerName: 'Megállóba érkezés ideje',
        width: 230,
        sortable: true,
        headerAlign: 'left',
        align: 'left',
        type: 'dateTime',
        headerClassName: 'headerName',
        renderHeader: () => <strong>Megállóba érkezés ideje</strong>,
        filterOperators: getGridDateOperators(true).filter(({ value }) => ['onOrAfter', 'onOrBefore'].includes(value)),
        valueFormatter: params => {
            return format(new Date(params.value as string), 'yyyy.MM.dd HH:mm:ss');
        },
    },
    {
        field: 'shift',
        headerName: 'Műszak',
        width: 160,
        sortable: true,
        headerAlign: 'left',
        align: 'left',
        renderHeader: () => <strong>Műszak</strong>,
        filterOperators: getGridStringOperators().filter(({ value }) => ['contains'].includes(value)),
    },
    {
        field: 'language',
        headerName: 'Nyelv',
        width: 80,
        sortable: true,
        headerAlign: 'right',
        align: 'right',
        renderHeader: () => <strong>Nyelv</strong>,
        filterOperators: getGridStringOperators().filter(({ value }) => ['contains'].includes(value)),
    },
];

export const getWorkerDeviceDataGridId = (device: WorkerDeviceDetailsByTravel) => {
    return device.id + '_' + device.deviceToken;
}

export default function WorkerDeviceDataGrid({
                                                 loading,
                                                 workerDeviceDetailsByTravels,
                                                 rowSelectionModel,
                                                 setRowSelectionModel
                                             }: WorkerDeviceDataGridProps) {
    return <>
        {loading ? (
            <ListContainer>
                <LoadingSpinner />
            </ListContainer>
        ) : (
            workerDeviceDetailsByTravels.length > 0 ? (
                <Stack sx={{ height: 'calc(100vh - 500px)', mt: 1 }}>
                    <ErrorBoundary>
                        <DataGridPro
                            density={'compact'}
                            columns={columns}
                            rows={workerDeviceDetailsByTravels}
                            initialState={{
                                sorting: {
                                    sortModel: [
                                        { field: 'departureAt', sort: 'asc' },
                                        { field: 'line', sort: 'asc' },
                                        { field: 'workplaceName', sort: 'asc' },
                                        { field: 'language', sort: 'asc' },
                                    ],
                                },
                            }}
                            rowHeight={35}
                            checkboxSelection
                            hideFooter={true}
                            getRowId={(row: WorkerDeviceDetailsByTravel) => getWorkerDeviceDataGridId(row)}
                            rowSelectionModel={rowSelectionModel}
                            onRowSelectionModelChange={(selectedRows) => {
                                setRowSelectionModel(selectedRows);
                            }}
                            localeText={huHU.components.MuiDataGrid.defaultProps.localeText}
                            unstable_headerFilters
                        />
                    </ErrorBoundary>
                </Stack>
            ) : (
                <ListContainer>
                    <EmptyListMessage />
                </ListContainer>
            )
        )}
    </>;
};